import React from 'react';
import { companyInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      'Software Development',
      'PAM Systems',
      'Infrastructure',
      'API Integration',
      'Technical Support',
    ],
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Services', href: '#services' },
      { name: 'Solutions', href: '#solutions' },
      { name: 'Compliance', href: '#compliance' },
      { name: 'Contact', href: '#contact' },
    ],
  };

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">B</span>
              </div>
              <span className="text-white font-semibold text-lg">
                Botlab<span className="text-blue-400"> Solutions</span>
              </span>
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed">
              Enterprise software solutions for the digital economy. We build scalable, 
              secure, and high-performance platforms that power modern businesses.
            </p>
            <div className="space-y-2 text-sm">
              <p className="text-slate-500">
                <span className="text-slate-400">Legal Entity:</span> {companyInfo.legalType}
              </p>
              <p className="text-slate-500">
                <span className="text-slate-400">Authority:</span> {companyInfo.authority}
              </p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((service) => (
                <li key={service}>
                  <span className="text-slate-400 hover:text-blue-400 transition-colors cursor-default text-sm">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-slate-400 hover:text-blue-400 transition-colors text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Address Bar */}
        <div className="py-6 border-t border-slate-800">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <p className="text-slate-500 text-sm">
                <span className="text-slate-400">Registered Address:</span>
              </p>
              <p className="text-slate-400 text-sm mt-1">
                {companyInfo.address}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <span className="px-3 py-1 bg-blue-500/10 text-blue-400 text-xs font-medium rounded-full border border-blue-500/20">
                RAKEZ Licensed
              </span>
              <span className="px-3 py-1 bg-slate-800 text-slate-400 text-xs font-medium rounded-full">
                B2B Only
              </span>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="py-6 border-t border-slate-800">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-slate-600 text-xs">
              A technology company providing B2B software solutions.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
